
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/verification-agreement",
      function () {
        return require("private-next-pages/docs/verification-agreement.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/verification-agreement"])
      });
    }
  